import { UploadedImageData } from 'editor/src/store/gallery/types';

/** Host payloads are unchecked at runtime, and the gallery mapping reads `file` and `url` without guards. */
const isUploadedImageData = (value: unknown): value is UploadedImageData => {
  const image = value as Partial<UploadedImageData> | null | undefined;
  return typeof image?.url === 'string' && typeof image.file?.id === 'string';
};

export default isUploadedImageData;
